module.exports = __webpack_public_path__ + "img/banner-13.b4eb6b15.jpg";